<template>
  <div>
    <div v-show="!fullyLoaded">
      <img
        src="https://assets.stihldealer.net/common/spinner.svg"
        style="width: 50px; margin: auto"
        alt="loading icon"
      >
    </div>
    <div v-show="fullyLoaded">
      <input
        type="hidden"
        name="price"
        :value="selectedVariant.price"
      >
      <div class="tw-pt-2 tw-font-bold tw-flex tw-items-center">
        <ProductPrice 
          class="tw-flex-grow"
          :price="selectedVariant.price"
          :dsrp="!selectedVariant.allowPurchase"
          :view-in-cart="selectedVariant.viewInCart"
        />

        <div v-if="selectedVariant.isInStock">
          In Stock
        </div>
        <div v-if="selectedVariant.isLimitedStock">
          Limited Stock
        </div>
        <div v-if="selectedVariant.isOutOfStock">
          Unavailable
        </div>
      </div>
      <input
        type="hidden"
        name="attributeId"
        :value="selectedVariant.id"
      >
      <VariantSelector
        :variants="variants"
        :selected-variant="selectedVariant"
        :category-name="categoryName"
        :product-name="productName"
        @select-variant="selectedVariant = $event"
      />

      <input
        type="hidden"
        name="quantity"
        :value="quantity"
      >
      <QuantitySelector
        :quantity="quantity"
        @update-qty="quantity = $event"
      />
      <input
        type="hidden"
        name="deliveryType"
        :value="deliveryType"
      >
      <DeliveryOptions
        v-if="!isOutfitters"
        v-model="deliveryType"
        :variant="selectedVariant"
        :shipping-settings="shippingSettings"
        :delivery-settings="deliverySettings"
        :variant-delivery-info="variantDeliveryInfo"
        :dealer-id="dealerId"
        :dealer-name="dealerName"
        :quantity="quantity"
        :dealer-api-url="dealerApiUrl"
        :enabled="deliveryOptionsEnabled"
        @update="deliveryType = $event"
        @setAddress="updateAddress"
        @loaded="deliveryLoaded = true"
      />
    
      <CallToAction
        :variant="selectedVariant"
        :express="express"
        :is-outfitters="isOutfitters"
        :sku="sku"
      />
    </div>    
  </div>
</template>


<script>
import ProductPrice from "./components/ProductPrice.vue";
import QuantitySelector from "./components/QuantitySelector.vue";
import VariantSelector from "./components/VariantSelector.vue";
import DeliveryOptions from './components/DeliveryOptions.vue'
import CallToAction from './components/CallToAction.vue'
import { loadGmapApi } from "vue2-google-maps";
import api from './api/index'

export default {
  components: {
    ProductPrice,
    QuantitySelector,
    VariantSelector,
    DeliveryOptions,
    CallToAction
  },  
  props: {
    dealerApiUrl: {
      type: String,
      required: true
    },
    dealerId: {
      type: Number,
      required: true
    },
    dealerName: {
      type: String,
      required: true
    },
    googleMapsApiKey: {
      type: String,
      required: true
    },
    isOutfitters: {
      type: Boolean,
      required: true
    },
    express: {
      type: Boolean,
      required: true
    },
    sku: {
      type: String,
      required: true
    },
    categoryName: {
      type: String,
      required: true
    },
    productName: {
      type: String,
      required: true
    },
    useInventory: {
      type: Boolean,
      required: false
    },
  },
  data() {
    return {
      variants: [],
      selectedVariant: {},
      deliverySettings: {
        enabled: false
      },
      shippingSettings: {
        enabled: false
      },
      variantDeliveryInfo: [],
      deliveryType: 'PickUp',
      quantity: 1,
      loaded: false,
      deliveryLoaded: false
    }
  },
  computed: {
    fullyLoaded() {
      return this.loaded && (this.deliveryLoaded || this.isOutfitters)
    },
    deliveryOptionsEnabled() {
      return this.express && (this.selectedVariant?.allowPurchase ?? false)
    },
  },
  async mounted() {
    this.variants = window.b2c.buynow.variants;
    this.selectedVariant = this.variants.find((t) => t.allowPurchase) ?? this.variants[0];
    const attributeIds = this.variants.map(t=>t.id)
    const response = await api.getSettings(this.dealerApiUrl, this.dealerId, attributeIds)
    this.variantDeliveryInfo = response.attributes;
    if (response.deliverySettings) {
      this.deliverySettings = response.deliverySettings
    }
    if (response.shippingSettings) {
      this.shippingSettings = response.shippingSettings
    }

    if (this.useInventory) {
      const inventoryList = await api.getInventory(this.dealerApiUrl, this.dealerId, attributeIds)
      this.variants.forEach((v) => {
        const inventory = inventoryList.find((i) => i.attributeId == v.id)
        v.isInStock = inventory ? inventory.isInStock : false
        v.isLimitedStock = inventory ? inventory.isLimitedStock : false
        v.isOutOfStock = inventory ? inventory.isOutOfStock : false
        if (v.isOutOfStock)
          v.allowPurchase = false
      });
    }

    this.loaded = true
  },
  beforeMount() {
    loadGmapApi({
      key: this.googleMapsApiKey,
      libraries: "places",
    });
  },
  methods: {
    updateAddress () {
      const storage = localStorage.getItem('Delivery.Address')
      if (storage) {
        try {
          const address = JSON.parse(storage)
          this.address = address
        } catch {
          // we dont want to blow up if address cant be parsed
        }
      }
    },
  }
}
</script>

